const PLANS = {
  PROFESSIONAL: 'PROFESSIONAL',
  ENTERPRISE: 'ENTERPRISE',
  EXPERTO: 'EXPERTO', // Ayuntamiento
  VALIDACION: 'VALIDACION',
};

export { PLANS }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/config/plans.config.js